import { z } from 'zod';

export const couponFormSchema = z
  .object({
    name: z
      .string()
      .min(1, { message: 'Coupon name is required' })
      .max(25, { message: 'Coupon name must be 25 characters or less' }),

    code: z.string().min(1, { message: 'Coupon code is required' }),

    coupon_type: z.enum(['generic', 'business_specific'], {
      required_error: 'Coupon type is required'
    }),

    discount_value: z.coerce.number().min(0.01, { message: 'Discount value must be greater than 0' }),

    discount_type: z.enum(['percentage', 'fixed_amount'], {
      required_error: 'Discount type is required'
    }),

    total_amount: z.coerce.number().optional().nullable(),

    date_range: z.string().min(1, { message: 'Start and end dates are required' }),

    validity_period: z.coerce.number().min(1, { message: 'Validity period must be at least 1 month' }).optional(),

    specific_resource_ids: z.array(z.number()).optional()
  })
  .superRefine((data, ctx) => {
    // percentage discount cannot exceed 100%
    if (data.discount_type === 'percentage' && data.discount_value > 100) {
      ctx.addIssue({
        path: ['discount_value'],
        code: z.ZodIssueCode.custom,
        message: 'Percentage discount cannot exceed 100%'
      });
    }

    if (data.discount_type === 'percentage' && (!data.total_amount || data.total_amount <= 0)) {
      ctx.addIssue({
        path: ['total_amount'],
        code: z.ZodIssueCode.custom,
        message: 'Total amount must be greater than 0'
      });
    }

    // if coupon type is business_specific, at least one business required
    if (
      data.coupon_type === 'business_specific' &&
      (!data.specific_resource_ids || data.specific_resource_ids.length === 0)
    ) {
      ctx.addIssue({
        path: ['specific_resource_ids'],
        code: z.ZodIssueCode.custom,
        message: 'Please select at least one business'
      });
    }
  });
